import * as React from 'react';
import { VisualTileWrapper, DownloadButton } from './VisualTile_SC';
import { IconButton } from '@inmoment/the-kitchen';

export interface Props {
  children?: React.ReactNode;
  text: string;
  downloadPath?: string;
  color?: 'orca' | 'white';
  onClick(): void;
}

export const VisualTile: React.FC<Props> = (props) => {
  const { text, color = 'white', children, downloadPath, onClick } = props;

  return (
    <VisualTileWrapper key={text} onClick={onClick} color={color}>
      {children}
      <div style={{ position: 'absolute', bottom: 0 }}>
        <p
          className={`kxi-text-small ${color === 'white' ? 'orca' : 'white'} ${text}`}
          style={{ maxWidth: 120, textOverflow: 'ellipsis', overflow: 'hidden' }}
        >
          {text}
        </p>
      </div>
      {downloadPath && (
        <DownloadButton
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <a href={downloadPath} target="_blank" rel="noopener noreferrer" download>
            <IconButton icon={'download'} contrast={color === 'white' ? 'normal' : 'high'} />
          </a>
        </DownloadButton>
      )}
    </VisualTileWrapper>
  );
};
